import {
  PayeeRequirement,
  PayerEngagement
} from "@wingspanhq/wingspan-api-sdk";
import { selectorHasEligiblePayerEngagement } from "./selectorHasEligiblePayerEngagement";
import { selectorIsPayerEngagementEligible } from "./selectorIsPayerEngagementEligible";

/**
 * Whether the client's assignments are fully in order: every assignment has all
 * its requirements complete, AND at least one live assignment is eligible.
 *
 * The second half is not redundant — a client with no live assignment vacuously
 * satisfies the first. Mirrors v1's
 * `getAllEngagementsEligibilityRequirementsCompleted`.
 */
export const selectorAreAllPayerEngagementRequirementsComplete = ({
  engagements,
  requirements
}: {
  engagements: PayerEngagement[];
  requirements: PayeeRequirement[];
}): boolean =>
  engagements.every(engagement =>
    selectorIsPayerEngagementEligible({ engagement, requirements })
  ) && selectorHasEligiblePayerEngagement({ engagements, requirements });
